import { render, staticRenderFns } from "./ManageCredits.vue?vue&type=template&id=78a859db&scoped=true&"
import script from "./ManageCredits.vue?vue&type=script&lang=ts&"
export * from "./ManageCredits.vue?vue&type=script&lang=ts&"
import style0 from "./ManageCredits.vue?vue&type=style&index=0&id=78a859db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a859db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78a859db')) {
      api.createRecord('78a859db', component.options)
    } else {
      api.reload('78a859db', component.options)
    }
    module.hot.accept("./ManageCredits.vue?vue&type=template&id=78a859db&scoped=true&", function () {
      api.rerender('78a859db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dancers/credits/ManageCredits.vue"
export default component.exports